import React, { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";

import {
  fetchRehabPlans,
  deleteRehabPlan,
  clearError,
} from "../store/slices/individualisedRehabPlanSlice";
import IndividualisedRehabPlanList from "./Phase-05/IndividualisedRehabPlan/IndividualisedRehabPlanList";

const IndividualisedRehabPlans = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patientId } = useParams(); // optional – /patient/:id

  // ---- Redux state -------------------------------------------------
  const {
    rehabPlans,
    isLoading,
    error,
  } = useSelector((state) => state.individualisedRehabPlan);

  // ---- Permissions (replace with your real logic) ------------------
  const canManage = true;
  const canCreate = true;
  const canEdit = true;
  const canDelete = true;

  // ---- Load data ----------------------------------------------------
  useEffect(() => {
    dispatch(fetchRehabPlans(patientId || null));
    return () => dispatch(clearError());
  }, [dispatch, patientId]);

  // ---- Handlers ----------------------------------------------------
  const handleAdd = () => navigate("/phase05/individualised-rehab-plan/add");

  const handleEdit = (id) =>
    navigate(`/phase05/individualised-rehab-plan/edit/${id}`);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This Individualised Rehab Plan will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const res = await dispatch(deleteRehabPlan(id));
      if (deleteRehabPlan.fulfilled.match(res)) {
        Swal.fire("Deleted!", "Record has been removed.", "success");
      } else {
        Swal.fire("Error", res.payload || "Failed to delete", "error");
      }
    }
  };

  // ---- Permission guard --------------------------------------------
  if (!canManage) {
    return (
      <Navigate
        to="/dashboard"
        state={{
          error: "You do not have permission to manage Individualised Rehab Plans.",
        }}
        replace
      />
    );
  }

  // ---- Render -------------------------------------------------------
  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        {/* Error alert */}
        {error && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Error:</strong> {error}
            <button
              type="button"
              className="btn-close"
              onClick={() => dispatch(clearError())}
            />
          </div>
        )}

        <div className="card">
          <div className="card-body">
            {isLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <IndividualisedRehabPlanList
                records={rehabPlans}
                onAdd={canCreate ? handleAdd : null}
                onEdit={canEdit ? handleEdit : null}
                onDelete={canDelete ? handleDelete : null}
              />
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default IndividualisedRehabPlans;